<template>
    <j-modal :title="title" :width="1000" :visible="visible" :confirmLoading="confirmLoading" :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }" @ok="handleOk" @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
        <a-spin :spinning="confirmLoading">
            <j-form-container>
                <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
                    <a-row :gutter="24">
                        <a-col :span="24">
                            <a-form-model-item prop="newMeterId">
                                <a-button @click="handleAddEquipment" type="primary" icon="plus">{{ $t('添加设备信息') }}</a-button>
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <a-row :gutter="24">
                        <a-divider orientation="left">{{ $t('新表具信息') }}</a-divider>
                        <a-col :span="24" v-if="model.newMeterId">
                            <detail-list>
                                <detail-list-item :term="$t('新表编号')">{{model.newMeterId}}</detail-list-item>
                                <detail-list-item :term="$t('新表口径')">{{'DN'+model.mtCaliber}}</detail-list-item>
                                <detail-list-item :term="$t('新表类型')">{{model.mtName}}</detail-list-item>
                            </detail-list>
                        </a-col>
                    </a-row>
                    <a-row :gutter="24">
                        <a-col :span="8">
                            <a-form-model-item :label="$t('新表表端累计读数(m³)')" prop="meterTotalUse">
                                <a-input v-model="model.meterTotalUse" disabled />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-model-item :label="$t('上报时间')" prop="sysTime">
                                <a-input v-model="model.sysTime" disabled />
                            </a-form-model-item>
                        </a-col>
                        <a-col :span="8">
                            <a-form-model-item :label="$t('新表开始计费读数(m³)')" prop="meterStartNum">
                                <a-input v-model="model.meterStartNum" :placeholder="$t('请输入新表开始计费读数')" />
                            </a-form-model-item>
                        </a-col>
                    </a-row>
                    <!-- <a-row :gutter="24">
            <a-divider orientation="left">旧表具信息</a-divider>
            <a-col :span="8">
              <a-form-model-item label="旧表机械读数(m³)" prop="meterOldMachineSumFlow">
                <a-input v-model="model.meterOldMachineSumFlow" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="换表原因" prop="meterChangeType">
                <a-input v-model="model.meterChangeType" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="新表开始计费读数(m³)" prop="newMeterNum">
                <a-input v-model="model.newMeterNum" placeholder="请输入新表开始计费读数" />
              </a-form-model-item>
            </a-col>
          </a-row> -->
                    <!-- <a-row :gutter="24">
            <a-col :span="8">
              <a-form-model-item label="是否以旧表机械数计算" prop="whetherSettlementOldTable">
                <a-select v-model="queryParam.whetherSettlementOldTable" placeholder="请选择是否以旧表机械数计算">
                  <a-select-option :value="1">是</a-select-option>
                  <a-select-option :value="0">否</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="换表后账户剩余金额" prop="meterUserAccountNumAfterChange">
                <a-input v-model="model.meterUserAccountNumAfterChange" disabled />
              </a-form-model-item>
            </a-col>
            <a-col :span="8">
              <a-form-model-item label="换表后旧表最后一次读数(m³)" prop="meterOldSumFlowAfterChange">
                <a-input v-model="model.meterOldSumFlowAfterChange" placeholder="请输入新表开始计费读数" />
              </a-form-model-item>
            </a-col>
          </a-row> -->
                    <!-- <a-col :span="24">
              <a-form-model-item label="下一节点操作人" prop="candidateUsers">
                <a-select mode="multiple" v-model="model.candidateUsers" placeholder="请选择操作人">
                  <a-icon slot="suffixIcon" type="smile" />
                  <a-select-option v-for="item in candidateUsersList" :value="item.userName">{{item.userRealname}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col> -->
                    <!-- </a-row> -->
                </a-form-model>
            </j-form-container>
        </a-spin>
        <j-modal :title="$t('选择新表')" :width="1200" :visible="equipmentModalVisible" :maskClosable="false" @ok="handleOk1" @cancel="handleCancel1" :okText="$t('确定')" :cancelText="$t('关闭')">
            <div class="table-page-search-wrapper">
                <a-form layout="inline" @keyup.enter.native="searchQuery">
                    <a-row :gutter="24">
                        <a-col :xl="6" :lg="7" :md="8" :sm="24">
                            <a-form-item :label="$t('表编号')">
                                <j-input :placeholder="$t('表编号模糊查询')" v-model="queryParam.meterId"></j-input>
                            </a-form-item>
                        </a-col>
                        <a-col :xl="6" :lg="7" :md="8" :sm="24">
                            <a-form-item :label="$t('表类型')">
                                <a-select v-model="queryParam.mtCode" :placeholder="$t('请选择表类型')">
                                    <a-select-option v-for="data in userTypeList" :key="data.id" :value="data.id">
                                        {{data.mtName}}
                                    </a-select-option>
                                </a-select>
                            </a-form-item>
                        </a-col>
                        <a-col :xl="6" :lg="7" :md="8" :sm="24">
                            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                            </span>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <a-table ref="table" size="middle" :bordered="false" rowKey="id" :columns="columns" :dataSource="dataSource" :pagination="ipagination" :loading="loading" :scroll="{ x: 'max-content' }" :rowSelection="{ type: 'radio', selectedRowKeys: selectedRowKeys, onChange: onSelectChange }" :customRow="customRow" @change="handleTableChange">
            </a-table>
        </j-modal>
    </j-modal>
</template>

<script>
import {
    JeecgListMixin
} from '@/mixins/JeecgListMixin';
import {
    httpAction,
    getAction,
    postAction
} from '@/api/manage'
import {
    validateDuplicateValue
} from '@/utils/util'
import DetailList from '@/components/tools/DetailList'
const DetailListItem = DetailList.Item
import JInput from '@/components/jeecg/JInput'
export default {
    mixins: [JeecgListMixin],
    name: 'auditModal',
    components: {
        DetailList,
        DetailListItem,
        JInput
    },
    data() {
        return {
            title: '',
            width: 800,
            visible: false,
            disableSubmit: false,
            confirmLoading: false,
            model: {},
            url: {
                list: "/jeecg-charge/meter/meterinfo/list",
                edit: "/jeecg-engineering/ticket/ticketsChangeMeter/edit",
                pass: "/jeecg-engineering/flowable/task/completeByDateId",
                userList: "/jeecg-engineering/ticket/ticketsUser/list",
                userTypeList: "/jeecg-charge/meter/meterType/list",  //表类型请求地址
                editApproverName: "/jeecg-engineering/ticket/tickets/editApproverName",
                queryNoAreaPageList: "/jeecg-charge/meter/meterUpData/queryNoAreaPageList"
            },
            equipmentModalVisible: false,
            dataSource: [],
            passId: '',
            candidateUsersList: [],
            queryParam: {
                mtState: 0
            },
            userTypeList: [],  //表类型
        }
    },
    computed: {
        validatorRules() {
            return {
                candidateUsers: { required: true, message: this.$t('请选择下一节点操作人'), trigger: 'change' },
                meterStartNum: { required: true, message: this.$t('请输入新表开始计费读数'), trigger: 'change' },
                newMeterId:{ required: true, message: this.$t('请选择添加设备信息'), trigger: 'change' }
            }
        },
        // 表头
        columns() {
            return [{
                title: '#',
                dataIndex: '',
                key: 'rowIndex',
                width: 60,
                align: "center",
                customRender: (t, r, index) => {
                    return parseInt(index) + 1;
                }
            },
            {
                title: this.$t('表编号'),
                align: "center",
                dataIndex: 'meterId'
            },
            {
                title: this.$t('表类型'),
                align: "center",
                dataIndex: 'mtName'
            }
            ]
        },
    },
    methods: {
        customRow(record, index) {
            return {
                on: {
                    click: (e) => {
                        this.selectedRowKeys = [e.currentTarget.dataset.rowKey];
                    }
                }
            }
        },
        queryUserTypeList() {   //表类型请求
            let params = {}
            params.pageNo = 1;
            params.pageSize = 999;
            getAction(this.url.userTypeList, params).then((res) => {
                if (res.success) {
                    this.userTypeList = res.result.records;
                }
            })
        },
        getUserList() {
            getAction(this.url.userList, { pageSize: 999 }).then(res => {
                if (res.success) {
                    this.candidateUsersList = res.result.records;
                }
            })
        },
        init(row) {
            this.title = this.$t('绑定新表');
            this.visible = true;
            this.model.id = row.ticketsForeignId;
            this.model.ticketsType = row.ticketsType;
            this.model.ticketsId = row.id;
            this.passId = row.id;
            this.getUserList();
            this.queryUserTypeList();
        },
        handleCancel() {
            this.visible = false;
        },
        handleOk() {
            const that = this;
            // 触发表单验证
            this.$refs.form.validate(valid => {
                if (valid) {
                    that.confirmLoading = true;
                    postAction(this.url.edit, this.model).then((res) => {
                        if (res.success) {
                            // that.$message.success(res.message);
                            let params = {
                                // candidateUsers: that.model.candidateUsers,
                                dataId: that.passId,
                                values: {
                                    dataId: that.passId,
                                },
                                comment: ''
                            }
                            postAction(this.url.pass, params).then(res => {
                                if (res.success) {
                                    // // 更新节点处理人
                                    // postAction(that.url.editApproverName,{
                                    //   ticketsId: that.model.ticketsId,
                                    //   ticketsType: that.model.ticketsType,
                                    //   approverName: that.model.candidateUsers.join(','),
                                    // }).then(val=>{
                                    //   if(res.success){
                                    //     // that.$message.success('更新节点处理人成功');
                                    //     that.$message.success('绑定新表成功');
                                    //     that.$emit('ok');
                                    //     this.visible = false;
                                    //   }
                                    // });
                                    that.$message.success(this.$t('绑定新表成功'));
                                    that.$emit('ok');
                                    that.visible = false;
                                    that.confirmLoading = false;
                                } else {
                                    that.$message.warning(res.message);
                                }
                            });
                        } else {
                            that.$message.warning(res.message);
                        }
                    })

                    // .finally(() => {
                    //   that.confirmLoading = false;
                    // })
                }

            })
        },
        // 添加设备信息
        handleAddEquipment() {

            
            this.equipmentModalVisible = true;
        },
        handleCancel1() {
            this.equipmentModalVisible = false;
        },
        handleOk1() {
            let info = this.dataSource.find(item => item.id == this.selectedRowKeys[0]);
            this.$set(this.model, 'newMeterId', info.meterId);
            this.$set(this.model, 'mtCaliber', info.mtCaliber);
            this.$set(this.model, 'mtName', info.mtName);
            getAction(this.url.queryNoAreaPageList, { meterId: info.meterId }).then(res => {
                if (res.success) {
                    // debugger
                    var meterInfo = res.result.records[0];
                    this.$set(this.model, 'sysTime', meterInfo.sysTime);
                    this.$set(this.model, 'meterTotalUse', meterInfo.meterTotalUse);
                }
            })
            this.equipmentModalVisible = false;
        },
    }
}
</script>